import {useQuery} from 'react-query';
import {getSummaryStateList} from './getSummaryStateList';

const useGetSummaryStateList = () => {
  const {data, isLoading} = useQuery({
    queryKey: ['summary-state-list'],
    queryFn: () => getSummaryStateList(),
  });

  return {data, isLoading};
};

export default useGetSummaryStateList;
